import { useState, useCallback } from 'react';

// Smart targeting: a click earlier than the current start becomes the new start;
// later than the current end becomes the new end; otherwise it fills the active input.
export function useRangeSelection(initialRange) {
  const [draft, setDraft] = useState(initialRange);
  const [activeInput, setActiveInput] = useState('start');
  const [hoverPreview, setHoverPreview] = useState(null);

  const onDayClick = useCallback((day) => {
    setDraft((prev) => {
      if (prev.start && day < prev.start) { setActiveInput('end'); return { start: day, end: prev.end }; }
      if (prev.end && day > prev.end) { setActiveInput('start'); return { start: prev.start, end: day }; }
      if (activeInput === 'start') { setActiveInput('end'); return { start: day, end: prev.end }; }
      setActiveInput('start');
      return { start: prev.start, end: day };
    });
  }, [activeInput]);

  const onDayHover = useCallback((day) => setHoverPreview(day), []);
  // Clearing the preview on mouse-leave keeps a stale highlight from lingering
  // after the cursor leaves the grid; without it the last-hovered range stays lit.
  const onDayLeave = useCallback(() => setHoverPreview(null), []);
  // reset also drops any hover preview so a range applied via preset/cancel/sync
  // never inherits a highlight from a previous hover.
  const reset = useCallback((range) => { setDraft(range); setActiveInput('start'); setHoverPreview(null); }, []);

  return {
    draft, activeInput, setActiveInput, onDayClick, onDayHover, onDayLeave, hoverPreview, reset,
  };
}
